export default __webpack_public_path__ + "static/media/27.52f24615.jpg";